export default [
  {
    path: "/wx_auth",
    name: "wx_auth",
    component: () => import("@/views/WechatAuth.vue"),
    meta: {
      index: 1
    }
  },
  {
    path: "/zsplus_auth",
    name: "zsplus_auth",
    component: () => import("@/views/ZsplusAuth.vue")
  },
  {
    path: "/empty",
    name: "empty",
    component: () => import("@/views/EnvEmpty.vue")
  }
];
